<script setup lang="ts">
export interface RecipeInfoStatsProps {
  energy?: number | null;
  cookingTime?: number | null;
  estimatedCost?: number | null;
}

defineProps<RecipeInfoStatsProps>();
</script>

<template>
  <div class="flex">
    <div
      v-if="energy"
      class="w-full text-pink-400 text-center not-last:border-r border-cream-500 mr-1.5 pr-1.5"
    >
      <div class="text-2xl font-dietplus-runes before:content-['\eb18']" />
      <p class="font-bold text-sm mb-0.5">{{ energy }}kcal</p>
      <p class="text-xs">総エネルギー量</p>
    </div>

    <div
      v-if="cookingTime"
      class="w-full text-gray-500 text-center not-last:border-r border-cream-500 mr-1.5 pr-1.5"
    >
      <div
        class="text-2xl font-dietplus-runes before:content-['\eb4f'] text-brown-300"
      />
      <p class="font-bold text-sm mb-0.5">約{{ cookingTime }}分</p>
      <p class="text-xs">調理時間</p>
    </div>

    <div v-if="estimatedCost" class="w-full text-gray-500 text-center">
      <div
        class="text-2xl font-dietplus-runes before:content-['\f157'] text-brown-300"
      />
      <p class="font-bold text-sm mb-0.5">約{{ estimatedCost }}円</p>
      <p class="text-xs">費用目安（1人分）</p>
    </div>
  </div>
</template>
